import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getManageLawProjectTracking } from '../../../redux/actions/adminManageLawProjectTracking'
// import LegalManagementWidget from '../../widgets/legalManagement/LegalManagementWidget'
import SaveLawTrackingWidget from '../../../widgets/saveLawTracking/SaveLawTrackingWidget'
// import './styles.less'
import CallBookNoticeWidget from '../../../widgets/callBookNotice/CallBookNoticeWidget'
import { getCallBookNotice } from '../../../redux/actions/callBookNotice'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

export default function CallBookNotice() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // const request = {
      //   lawType: null,
      //   projectCode: null,
      //   docNumberOfPurchase: null,
      //   contractNumberRef: null,
      //   pageNumber: 5,
      //   pageSize: 1,
      // }

      const _schema = await getCallBookNotice()
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal isLegalManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isLegalManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isLegalManagement>
        <ContentHeader
          header={schema?.header || 'จัดทำหนังสือทวงถาม (Notice)'}
          subHeader={schema?.subHeader}
          isNotCallApi
        />

        <CallBookNoticeWidget schema={schema} />

        <br />
    </SidebarProposal>
  )
}
